import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';

import {FriendsService} from '../../../services/friends.service';
import {BaseUserViewModel, UserFriendViewModel} from '../../../viewModels/userFriend.viewModel';

@Component({
    selector: 'app-friends-section',
    templateUrl: './friends-section.component.html',
    styleUrls: ['./friends-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FriendsSectionComponent implements OnInit {
    friends: UserFriendViewModel[] = [];
    search_text: string;
    search_friends: BaseUserViewModel[];

    constructor(
        private readonly friendsService: FriendsService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.loadFriends();
    }

    searchTextChanged() {
        if (this.search_text && this.search_text.length >= 3) {
            this.friendsService.searchFriends({search_text: this.search_text})
                .subscribe(friends => {
                    this.search_friends = friends;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    addFriend(email: string) {
        this.friendsService.createFriend({friend_email: email})
            .subscribe(() => {
                this.search_friends = null;
                this.search_text = null;
                this.loadFriends();
                this.changeDetectorRef.markForCheck();
            }, () => {
                this.search_friends = null;
                this.search_text = null;
                this.changeDetectorRef.markForCheck();
            });
    }

    removeFriend(id: number) {
        this.friendsService.removeFriend({id: id})
            .subscribe(() => {
                this.loadFriends();
            });
    }

    private loadFriends() {
        this.friendsService.getFriends().subscribe(friends => {
            this.friends = friends;
            this.changeDetectorRef.markForCheck();
        });
    }

}
